module.exports = __webpack_public_path__ + "static/media/mars-awakens-6.96ed0eba.jpg";